import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { NzDrawerComponent, NzDrawerContentDirective } from 'ng-zorro-antd/drawer';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { LoggingService } from '../../../generics/services/logging.service';
import { DebugSection } from '../../../generics/models/debug-section';
import { DebugSectionNames } from '../../../generics/enums/debug-section-names';
import { ContainerComponent } from '../container/container.component';

@Component({
    selector: 'debug-display-widget',
    templateUrl: './html/debug-display-widget.component.html',
    styleUrls: ['./css/debug-display-widget.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NzDrawerComponent,
        NzDrawerContentDirective,
        NgxJsonViewerModule,
        ContainerComponent,
        NzButtonComponent,
    ],
})
@UntilDestroy()
export class DebugDisplayWidgetComponent {
    @Input() visible: boolean;
    @Input() leadNumber: string;
    @Input() sections: DebugSection[] = [];
    @Output() closed = new EventEmitter<void>();

    // Track open/close state for each accordion
    public openAccordions: boolean[] = [];

    constructor(
        public store$: Store,
        private readonly loggingService$: LoggingService,
    ) {}

    onClickLogToExceptionless() {
        this.loggingService$.log({
            message: 'Debug Info Log',
            level: 'Info',
            tags: ['Debug', this.leadNumber],
            additionalInfo: [
                {
                    name: 'Quote State',
                    value: this.sections
                        .find((section) => section.label === DebugSectionNames.QUOTE_STATE)
                        .state(),
                },
                {
                    name: 'Vehicle State',
                    value: this.sections
                        .find((section) => section.label === DebugSectionNames.VEHICLE_STATE)
                        .state(),
                },
                {
                    name: 'Policy Holder',
                    value: this.sections
                        .find((section) => section.label === DebugSectionNames.POLICY_HOLDER_STATE)
                        .state(),
                },
                {
                    name: 'Household Member',
                    value: this.sections
                        .find(
                            (section) =>
                                section.label === DebugSectionNames.HOUSEHOLD_MEMBERS_STATE,
                        )
                        .state(),
                },
                {
                    name: 'Home Contents State',
                    value: this.sections
                        .find((section) => section.label === DebugSectionNames.HOME_CONTENTS_STATE)
                        .state(),
                },
                {
                    name: 'Payment Details',
                    value: this.sections
                        .find(
                            (section) => section.label === DebugSectionNames.PAYMENT_DETAILS_STATE,
                        )
                        .state(),
                },
            ],
        });
    }

    ngOnChanges() {
        // Reset open states if sections change
        this.openAccordions = this.sections.map(() => false);
    }

    toggleAccordion(index: number) {
        this.openAccordions[index] = !this.openAccordions[index];
    }
}
